import React, { useEffect, useState } from "react";
import Axios from "axios";
import { Avatar, CircularProgress, Pagination } from "@mui/material";

function formatAnswer(answer) {
  if (Array.isArray(answer)) return answer.join(", ");
  if (answer === null || answer === undefined || answer === "") return "-";
  return String(answer);
}

export default function OnboardingResponses() {
  const [responses, setResponses] = useState(null);
  const [count, setCount] = useState(0);
  const [page, setPage] = useState(1);
  const [role, setRole] = useState("");
  const [isCompleted, setIsCompleted] = useState("");

  const fetchResponses = async () => {
    const { data } = await Axios({
      method: "get",
      url: "/api/admin/onboarding/responses",
      params: {
        page,
        size: 20,
        ...(role ? { role } : {}),
        ...(isCompleted ? { isCompleted } : {}),
      },
    });
    setResponses(data.data);
    setCount(data.count);
  };

  useEffect(() => {
    fetchResponses();
  }, [page, role, isCompleted]);

  if (responses === null) {
    return <CircularProgress />;
  }

  return (
    <div className="container admin-user-activity">
      <h3>Onboarding Responses</h3>
      <div className="d-flex gap-2 my-2">
        <select
          value={role}
          onChange={(e) => {
            setPage(1);
            setRole(e.target.value);
          }}
        >
          <option value="">All Roles</option>
          <option value="startup">Startup</option>
          <option value="investor">Investor</option>
        </select>
        <select
          value={isCompleted}
          onChange={(e) => {
            setPage(1);
            setIsCompleted(e.target.value);
          }}
        >
          <option value="">All</option>
          <option value="true">Completed</option>
          <option value="false">In Progress</option>
        </select>
      </div>
      {responses.length > 0 ? (
        <>
          <table>
            <tr>
              <th>User</th>
              <th>Role</th>
              <th>Progress</th>
              <th>Answers</th>
              <th>Last Updated</th>
            </tr>
            {responses.map((res, i) => (
              <tr key={res._id || i} className="my-2 pt-2">
                <td className="my-2 pt-2">
                  <Avatar src={res.userId ? res.userId.avatar : ""} />
                  {res.userId ? res.userId.name : ""}:-{" "}
                  {res.userId
                    ? `${res.userId.firstname || ""} ${res.userId.lastname || ""}`
                    : ""}
                  <br />
                  <span style={{ fontSize: "12px", color: "#64748b" }}>
                    {res.userId?.email}
                  </span>
                </td>
                <td className="w-120px">{res.role}</td>
                <td className="w-120px">
                  {res.isCompleted ? (
                    <span style={{ color: "green" }}>Completed</span>
                  ) : (
                    <span style={{ color: "orange" }}>
                      In Progress ({res.completedQuestions})
                    </span>
                  )}
                </td>
                <td>
                  {res.answers && res.answers.length > 0
                    ? res.answers.map((a, idx) => (
                        <div key={idx}>
                          <b>
                            {a.question ? a.question.label : "Unknown question"}
                            :
                          </b>{" "}
                          {formatAnswer(a.answer)}
                        </div>
                      ))
                    : "-"}
                </td>
                <td>{new Date(res.updatedAt).toLocaleDateString()}</td>
              </tr>
            ))}
          </table>
          <div className="pagination">
            <Pagination
              count={count ? Math.ceil(count / 20) : 0}
              page={page}
              onChange={(e, v) => setPage(v)}
            />
          </div>
        </>
      ) : (
        <h2>No Reports</h2>
      )}
    </div>
  );
}
